import { getTaskIdFromStepId } from "library/get-task-id-from-step-id.mjs"

// Retrieve task base id from one that might include an asset suffix.
function getCompletionKey(id) {
    if (id.includes("!")) {
        const parts = id.toString().split("!")
        return `complete-${parts[0]}!${getTaskIdFromStepId(parts[1])}`
    }
    return getTaskIdFromStepId(id)
}

export { getCompletionKey }
export default { getCompletionKey }
